import React from 'react';

import { flagStyles } from '../settings';

const SvgFI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1632px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgFI;
